import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountSsoConnection} from 'src/openapi/admin/apis/AccountSingleSignOnApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ErrorPayload, SuccessPayload} from 'src/typedef';

type Props = {
    accountId: number,
};

export type SsoSettings = {
    ssoEnabled: boolean,
    ssoMandatory: boolean,
};

export const useGetAccountSSOSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async (signal: AbortSignal) => {
        const ssoResponse = await apiDispatch(getAccountSsoConnection({accountId}, {signal}));

        if (ssoResponse.payload.success) {
            const ssoEnabled = ssoResponse.payload.data.ssoEnabled;
            const ssoMandatory = ssoResponse.payload.data.ssoMandatory;

            return Promise.resolve({
                type: '',
                payload: {
                    success: true,
                    error: false,
                    data: {ssoEnabled, ssoMandatory},
                } as SuccessPayload<SsoSettings>,
            });
        } else if (ssoResponse.payload.error) {
            return Promise.resolve({type: '', payload: ssoResponse.payload});
        } else {
            return Promise.resolve({type: '', payload: {
                success: false,
                error: true,
                data: {message: 'Failed to load SSO settings'},
            } as ErrorPayload});
        }
    }, [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            ssoEnabled: false,
            ssoMandatory: false,
        },
        getDispatchAction,
    });
};
